module.exports = {
          srcSet: __webpack_public_path__ + "396c6d3c849c84ccf5593fee581965db-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "396c6d3c849c84ccf5593fee581965db-180.png",width: 180,height: 216}],
          src: __webpack_public_path__ + "396c6d3c849c84ccf5593fee581965db-180.png",
          toString:function(){return __webpack_public_path__ + "396c6d3c849c84ccf5593fee581965db-180.png"},
          
          width: 180,
          height: 216
        }